import { render } from "./FooterNavigationLink.vue?vue&type=template&id=648c0a5d&scoped=true"
import script from "./FooterNavigationLink.vue?vue&type=script&lang=js"
export * from "./FooterNavigationLink.vue?vue&type=script&lang=js"

import "./FooterNavigationLink.vue?vue&type=style&index=0&id=648c0a5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648c0a5d"]])

export default __exports__